<template>
    <!-- form fields for the contact section -->

    <section class="flex-column form-fields-contact">
        <!-- THE CONTACT : CIVILITY -->
        <el-form-item prop="civility" :label="$t.__('common.labels.civility')">
            <el-select
                v-model="civility"
                class="wp-10"
                :data-bot="getDatabot('civility', currentStore)"
            >
                <el-option
                    v-for="option in civilities"
                    :key="option.value"
                    :value="option"
                    :label="option.label"
                />
            </el-select>
        </el-form-item>

        <!-- THE CONTACT : lastname -->
        <el-form-item prop="name" :label="$t.__('common.labels.name')">
            <el-input
                ref="name"
                v-model="name"
                name="lastname"
                autocomplete="off"
                :data-bot="getDatabot('lastname', currentStore)"
            ></el-input>
        </el-form-item>
        <!-- THE CONTACT : name -->
        <el-form-item prop="forename" :label="$t.__('common.labels.first_name')">
            <el-input
                v-model="forename"
                name="firstname"
                autocomplete="off"
                :data-bot="getDatabot('firstname', currentStore)"
            ></el-input>
        </el-form-item>

        <!-- THE CONTACT : ROLE -->
        <el-form-item
            prop="role"
            :label="$t.__('thirds.thirdscomponents.FormFieldsContact.position')"
        >
            <el-input
                v-model="role"
                autocomplete="off"
                :data-bot="getDatabot('role', currentStore)"
            ></el-input>
        </el-form-item>

        <!-- THE CONTACT : BIRTHDATE -->
        <el-form-item prop="birthdate" :label="$t.__('common.labels.birthdate')">
            <el-date-picker
                v-model="birthdate"
                type="date"
                :format="datePickerFormat"
                :data-bot="getDatabot('birthdate', currentStore)"
                :placeholder="datePickerFormat.toUpperCase()"
            >
            </el-date-picker>
        </el-form-item>

        <!-- THE CONTACT : E-MAIL -->
        <el-form-item prop="email" :label="$t.__('common.labels.email')">
            <el-input
                ref="email"
                v-model="email"
                type="email"
                :data-bot="getDatabot('email', currentStore)"
                autocomplete="off"
                placeholder="contact@societe.com"
                @input="checkIfContactExists()"
            ></el-input>
            <div v-if="getContactsList.length > 0" class="alert alert-warning mt-3">
                {{ $l10n.__('Ce contact semble déjà exister sur cette société') }}
            </div>
            <form-fields-contacts-list
                mode="readOnly"
                readonly
                :current-list="getContactsList"
                :display-nb-suggestion="false"
            />
        </el-form-item>

        <!-- THE CONTACT : PHONE / MOBILE / FAX -->
        <contact-number :current-store="currentStore" :error="error" />
    </section>
</template>

<script>
import DataBotsFormsMixins from 'mixins/DataBotsFormsMixins';
import ContactNumber from 'vcomponents/thirds/thirdscomponents/FormFieldsNumberPhone.vue';
import FormFieldsContactsList from 'vcomponents/thirds/thirdscomponents/FormFieldsContactsList.vue';
import { createNamespacedHelpers } from 'vuex';

const corpStore = createNamespacedHelpers('corp');

export default {
    components: {
        ContactNumber,
        FormFieldsContactsList,
    },
    mixins: [DataBotsFormsMixins],
    props: {
        currentStore: {
            type: String,
            required: true,
        },
        error: {
            type: Object,
            required: false,
            default: () => {},
        },
    },
    computed: {
        ...corpStore.mapGetters(['datePickerFormat']),
        civilities() {
            return this.$store.getters[`${this.currentStore}/civilities`];
        },
        civility: {
            get() {
                return this.$store.getters[`${this.currentStore}/civility`];
            },
            set(value) {
                this.$store.commit(`${this.currentStore}/setCivility`, value);
            },
        },
        name: {
            get() {
                return this.$store.getters[`${this.currentStore}/name`];
            },
            set(value) {
                this.$store.commit(`${this.currentStore}/setName`, value);
            },
        },
        forename: {
            get() {
                return this.$store.getters[`${this.currentStore}/forename`];
            },
            set(value) {
                this.$store.commit(`${this.currentStore}/setForename`, value);
            },
        },
        email: {
            get() {
                return this.$store.getters[`${this.currentStore}/email`];
            },
            set(value) {
                this.$store.commit(`${this.currentStore}/setEmail`, value);
            },
        },
        getContactsList() {
            return this.$store.getters[`${this.currentStore}/getContactsList`];
        },
        role: {
            get() {
                return this.$store.getters[`${this.currentStore}/role`];
            },
            set(value) {
                this.$store.commit(`${this.currentStore}/setRole`, value);
            },
        },
        birthdate: {
            get() {
                return this.$store.getters[`${this.currentStore}/birthdate`];
            },
            set(value) {
                this.$store.commit(`${this.currentStore}/setBirthdate`, value);
            },
        },
    },
    methods: {
        checkIfContactExists() {
            if (this.email && this.email.length > 4) {
                this.$store.dispatch(`${this.currentStore}/checkIfContactExists`, this.email);
            }
        },
    },
};
</script>
